import React, {
  useEffect,
  Fragment,
} from 'react';
import { Button } from 'antd';

import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import Invitation from '../../components/team/Invitation';
import SignupList from '../../components/team/SignupList';
import SubscriptionList from '../../components/team/SubscriptionList';
import UserTable from '../../components/team/UserTable';

import {
  ADMIN_ID,
  DOCTOR_ID,
} from '../../constants/RoleConstants';
import { DELETED } from '../../constants/Status';

const TeamContainer = ({
  user,
  invitation,
  team,
  metadata: {
    data: {
      title = [],
      specialty = [],
      medicalGroup = [],
    },
  },
  actions,
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { actions.getTeamMembers(); }, []);

  const isAdmin = user.profile.roleId === ADMIN_ID;

  // TODO: Refactor the following three actions to directly update store
  //  with success response so that we don't have to get new team members.
  const deactivateUser = async (userId) => {
    await actions.deactivateUser(userId);
    await actions.getTeamMembers();
  };

  const deleteMember = async (userId) => {
    await actions.deleteMember(user.profile.currentTeamId, userId);
    await actions.getTeamMembers();
  };

  const handleClickApproveButton = async (userId) => {
    await actions.approveSignup(userId);
    await actions.getTeamMembers();
  };

  const deactivateOrRemove = ({ id, status }) => (
    <Button
      key="action"
      type="danger"
      disabled={team.isLoading || status === DELETED}
      onClick={async () => {
        if (isAdmin) await deactivateUser(id);
        else await deleteMember(id);
      }}
    >
      {isAdmin ? i18n.t(status === DELETED ? 'deactivated' : 'deactivate') : i18n.t('remove')}
    </Button>
  );

  return (
    <div className="TeamContainer">
      <h1>
        {i18n.t('team_Invitations')}
      </h1>
      <p className="lead">
        {i18n.t('changeMemberHere')}
      </p>
      <hr />
      {
        (isAdmin || user.profile.roleId === DOCTOR_ID) && (
          <UserTable
            title={<h2>{isAdmin ? i18n.t('doctors') : i18n.t('myTeamMembers')}</h2>}
            users={team.teamMembers}
            actions={[deactivateOrRemove]}
          />
        )
      }
      <Invitation
        user={user}
        invitation={invitation}
        actions={actions}
      />
      {
        isAdmin && (
          <Fragment>
            <SignupList
              signupList={user.signupList}
              isLoading={user.isLoading}
              metadata={{
                title,
                specialty,
                medicalGroup,
              }}
              actions={{
                ...actions,
                approveSignup: handleClickApproveButton,
              }}
            />
            <SubscriptionList
              subscriptions={team.subscriptions}
              isLoading={team.isSubscriptionLoading}
              actions={actions}
            />
          </Fragment>
        )
      }
    </div>
  );
};

export default connectActionsAndReducers(TeamContainer);



// WEBPACK FOOTER //
// ./src/containers/team/TeamContainer.js